module.exports = __webpack_public_path__ + "static/img/笛.64fc0b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wuqi/笛.png
// module id = KZ5J
// module chunks = 4